import React, { Component } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import PageRoute from './components/routes/PageRoute';
import RouteLogout from './components/RouteLogout';
import RouteSetToken from './components/RouteSetToken';
import RouteUnauthorized from './components/RouteUnauthorized';
import LandingPage from './components/landing/LandingPage';
import HomePage from './components/home/HomePage';
import ClientsPage from './components/clients/ClientsPage';
import UsersPage from './components/users/UsersPage';
import ProjectsPage from './components/projects/ProjectsPage';
import ReportsPage from './components/reports/ReportsPage';
import SettingsPage from './components/settings/SettingsPage';
import CurrentUserProvider from './components/CurrentUserProvider';
import CurrentUser from './components/CurrentUser';

import './assets/css/styles.css';

class App extends Component {
  render() {
    return (
      <Switch>
        <Route to="/" path="/set-token" component={RouteSetToken} />
        <Route
          render={() => (
            <CurrentUserProvider>
              <Switch>
                <Route
                  exact
                  path="/"
                  render={props =>
                    <CurrentUser
                      render={currentUser =>
                        currentUser ? (
                          <Redirect to="/home" />
                        ) : (
                            <LandingPage {...props} />
                          )
                      }
                    />
                  }
                />
                <Route path="/logout" component={RouteLogout} />
                <Route path="/unauthorized" component={RouteUnauthorized} />
                <PageRoute path="/home" component={HomePage} />
                <PageRoute path="/staff" component={UsersPage} />
                <PageRoute path="/requirements" component={ClientsPage} />
                <PageRoute path="/projects" component={ProjectsPage} />
                <PageRoute path="/reports" component={ReportsPage} />
                <PageRoute path="/settings" component={SettingsPage} />
              </Switch>
            </CurrentUserProvider>
          )} />
      </Switch>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js